module.exports = __webpack_public_path__ + "img/lotuss-coin.9b0d9ca8.png";